import React from 'react';
import { UpdateConfiguratorValue } from '../../Actions/Configurator/Configurator.action';
import { useDispatch } from 'react-redux';
import { ConfiguratorConstants } from '../../Models/Configurator/ConfiguratorConstants';
import { setConfiguratorModuleShareData } from '../../Actions/Configurator/Configurator.action';

const ConfiguratorShareData = (props) => {
    const dispatch = useDispatch();
    console.log(props);
    var dataModel = JSON.parse(props.sharedata);
    
    if (dataModel) {
        let configuratorModuleShareData = [];
        dataModel.map((x, index) => {            
            if (x.name === ConfiguratorConstants.TextInputModuleSectionsProperty || x.name === ConfiguratorConstants.WallSectionRoundedProperty
                || x.name === ConfiguratorConstants.WallSectionNonRoundedProperty || x.name === ConfiguratorConstants.WallTypeProperty) {
                    configuratorModuleShareData.push(x);
                }
                if (index === dataModel.length - 1) {
                    dispatch(setConfiguratorModuleShareData(configuratorModuleShareData));
                }            
            dispatch(UpdateConfiguratorValue(x.name, x.value, index === dataModel.length - 1 ? true : false));            
        });
    }    

    return null;
}

export default ConfiguratorShareData;